<div class="row hdrBar">
  <div class="col-lg-9 col-md-9 mg-a"></div>
  <div class="col-lg-3 col-md-3 mg-a">
    <span>Select Date:</span>
    <nz-date-picker
      [nzDisabledDate]="disabledDate"
      [nzFormat]="dateFormat"
      [(ngModel)]="slctdDt"
      (ngModelChange)="onChange($event)"
    ></nz-date-picker>
  </div>
</div>
<div class="main">
  @if (wghmntSmry&&wghmntSmry.length>0) {
  <div class="row">
    <ul class="cards">
      @for (w of wghmntSmry; track w) {
      <li class="cards_item">
        <div class="card_g" [ngStyle]="{ background: w.lnrBgcd }">
          <div class="card_content">
            <div class="row">
              <h1 class="crdHdr">{{ w.type == null ? "" : w.type }}</h1>
            </div>
            <div class="row">
              <div class="col card_prt">
                <h1 class="crdHdr_sb_sm">
                  {{ w.wghmnt == null ? 0 : w.wghmnt }}
                </h1>
                <h1 class="card_sub_title">weighment in Kgs</h1>
              </div>
              <div class="col card_prt">
                <h1 class="crdHdr_sb_sm">
                  {{ w.trgt_wt == null ? 0 : w.trgt_wt }}
                </h1>
                <h1 class="card_sub_title">Target Weighment</h1>
              </div>
              <div class="col card_prt">
                <h1 class="crdHdr_sb_sm">
                  {{ w.wghmnt_cvrg == null ? 0 : w.wghmnt_cvrg }} %
                </h1>
                <h1 class="card_sub_title">Weighment %</h1>
              </div>
            </div>
          </div>
        </div>
      </li>
      }
    </ul>
    <div class="row bg-wp">
      <h1 style="color: #2656ff; font-size: 16px">Weighment</h1>
      <div class="ds-card tbl grid">
        <app-data-grid
          class="p-8"
          style="width: 100%"
          [dataSource]="wghmntDtls"
          [legacyColumns]="columnDefs"
          [searchPanel]="true"
          [filterRow]="false"
          [filterPanel]="false"
          [groupPanel]="true"
          [columnChooser]="true"
          [allowExport]="true"
          exportFileName="ulb wise operated Trips"
          [pageSize]="10"
          [allowedPageSizes]="[10, 25, 50, 100]"
          [showPageSizeSelector]="true"
          [rowAlternationEnabled]="true"
          [showBorders]="true"
          [wordWrapEnabled]="true"
        >
        </app-data-grid>
      </div>
    </div>
  </div>
  } @if (wghmntSmry&&wghmntSmry.length==0) {
  <div class="text-center">No Data found for Selected Date</div>
  }
</div>
